import Vue, { KeepAlive } from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: "/index",
    name: "",
  },
  {
    path: "/index",
    name: "index",
    meta: { title: "设备注册引导", KeepAlive: false },
    component: () => import("@/views/main/index.vue"), // 懒加载
  },
  {
    path: "/wxPay",
    name: "wxPay",
    hidden: true,
    meta: { title: "收银台" },
    props: true,
    component: () => import("@/views/wxPay/index.vue"), // 懒加载
  },
  {
    path: "/wxMerchantAuth",
    name: "wxMerchantAuth",
    hidden: true,
    meta: { title: "扫码认证" },
    props: true,
    component: () => import("@/views/wxPay/wxMerchantAuth.vue"), // 懒加载
  },
  {
    path: "/zfbPay",
    name: "zfbPay",
    hidden: true,
    meta: { title: "收银台" },
    props: true,
    component: () => import("@/views/zfbPay/index.vue"), // 懒加载
  },
  {
    path: "/jiaolianPay",
    name: "jiaolianPay",
    hidden: true,
    meta: { title: "收银台" },
    props: true,
    component: () => import("@/views/jiaolianPay/index.vue"), // 懒加载
  },
  {
    path: "/zfbMerchantAuth",
    name: "zfbMerchantAuth",
    hidden: true,
    meta: { title: "扫码认证" },
    props: true,
    component: () => import("@/views/zfbPay/zfbMerchantAuth.vue"), // 懒加载
  },
  {
    path: "/paySuccess",
    name: "paySuccess",
    hidden: true,
    meta: { title: "支付成功" },
    props: true,
    component: () => import("@/views/wxPay/paySuccess.vue"), // 懒加载
  },
   {
    path: "/limitTable",
    name: "limitTable",
    hidden: true,
    meta: { title: "限额表" },
    props: true,
    component: () => import("@/views/limitTable.vue"), // 懒加载
  },
  {
    path: "/errPage",
    name: "errPage",
    hidden: true,
    meta: { title: "提示" },
    props: true,
    component: () => import("@/views/errPage.vue"), // 懒加载
  },
  {
    path: "/order",
    name: "order",
    meta: { title: "前往支付...", KeepAlive: false },
    component: () => import("@/views/thirdparty/index.vue"), // 懒加载
  },
  {
    path: "/onPay",
    name: "onPay",
    hidden: true,
    meta: { title: "收银台" },
    props: true,
    component: () => import("@/views/thirdparty/onPay.vue"), // 懒加载
  },
  {
    path: "/onError",
    name: "onError",
    hidden: true,
    meta: { title: "支付失败" },
    props: true,
    component: () => import("@/views/thirdparty/onError.vue"), // 懒加载
  },
   {
    path: "/onSuccess",
    name: "onSuccess",
    hidden: true,
    meta: { title: "支付成功" },
    props: true,
    component: () => import("@/views/thirdparty/onSuccess.vue"), // 懒加载
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
